import { Component, computed, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule, NgClass } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from 'apps/prompt-builder-FE/src/app/service/layout-service/layout.service';
import { Router, RouterLink } from '@angular/router';
import { LoginService } from '@app/service/auth-service/login.service';
import { Observable } from 'rxjs';
import { User } from '@core/interface';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';

@Component({
  selector: 'app-main-topbar',
  imports: [
    NgClass,
    RouterLink,
    CommonModule,
    ButtonModule,
    MenuModule,
    RouterModule,
  ],
  templateUrl: './main-topbar.component.html',
  styleUrl: './main-topbar.component.scss',
})
export class MainTopbarComponent implements OnInit, OnDestroy {
  items!: MenuItem[];
  user$: Observable<User | null>;
  userMenuItems: MenuItem[];

  constructor(
    public layoutService: LayoutService,
    private loginService: LoginService,
    private router: Router
  ) {
    this.user$ = this.loginService.authUser$;
    this.userMenuItems = [
      {
        label: 'Logout',
        icon: 'pi pi-fw pi-sign-out',
        command: () => this.logout(),
      },
    ];
    this.items = [
      {
        label: 'Home',
        routerLink: '/',
      },
      {
        label: 'Contact',
        routerLink: '/contact',
      },
    ];
  }

  ngOnInit(): void {
    this.loginService.initializeAuthState();
  }

  logout(): void {
    this.loginService.logout().subscribe(() => {
      this.router.navigate(['/auth/login']);
    });
  }

  @HostListener('window:resize')
  onResize() {
    // Reset mobile menu state when transitioning to desktop
    this.layoutService.resetMobileMenuState();

    // Force recomputation of the menu state when window is resized
    // This ensures the menu state updates properly when transitioning between mobile and desktop
    setTimeout(() => {
      // Trigger change detection by accessing the computed value
      this.isMenuOpen();
    }, 100);
  }

  // Computed property to check if menu is open (static mode and not inactive)
  isMenuOpen = computed(() => {
    const config = this.layoutService.layoutConfig();
    const state = this.layoutService.layoutState();

    // Check if we're on desktop and in static mode
    const isDesktop = this.layoutService.isDesktop();
    const isStaticMode = config.menuMode === 'static';
    const isMenuNotInactive = !state.staticMenuDesktopInactive;

    // Only apply menu-opened class when:
    // 1. We're on desktop (not mobile)
    // 2. Menu mode is static (not overlay)
    // 3. Menu is not inactive (not collapsed)
    const isOpen = isDesktop && isStaticMode && isMenuNotInactive;
    return isOpen;
  });

  toggleDarkMode() {
    this.layoutService.layoutConfig.update((state) => ({
      ...state,
      darkTheme: !state.darkTheme,
    }));
  }

  ngOnDestroy() {
    // Cleanup if needed
  }
}
